import "modules/KeyLockersDashboard/components/KeyLockerWarning/components/WarningNotification/WarningNotification.scss";

import type { TFunction } from "i18next";

type WarningNotificationProps = {
  t: TFunction;
};

export const WarningNotification = ({ t }: WarningNotificationProps) => (
  <div className="WarningNotification">
    <div className="container">
      <span className="title"> {t("v8_key_lockers_are_not_usable", "Key Lockers are not usable")} </span>
      <span className="body">
        {t(
          "v8_pin_codes_to_use_the_key_lockers_are_not_sent_to_the_customers_by_the_online_check_in_go_to_the_customer_communication_page_to_enable_it",
          "PIN codes to use the Key Lockers are not sent to the customers by the Online Check-in. Go to the Customer communication page to enable it."
        )}
      </span>
    </div>
  </div>
);
